import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`

interface ButtonProps {
  selected?: boolean
}

const Button = styled.div<ButtonProps>`
  display: flex;
  width: 144px;
  padding: 8px 0px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  border-radius: 8px;
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  /* 조건부 스타일 */
  ${({ selected }) =>
    selected
      ? `
        border: 1px solid var(--base-gray20, #dedede);
        background: var(--secondary80, #4282ef);
        color: var(--base-white100, #fff);
      `
      : `
        border: 1px solid var(--base-gray20, #dedede);
        background: var(--base-black5, rgba(0, 0, 0, 0.05));
        color: var(--base-gray80, #5e5e5e);
      `}
`

interface ButtonGroupProps {
  selectedButton: string
  onButtonClick: (buttonLabel: string) => void
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  selectedButton,
  onButtonClick,
}) => {
  const buttons = [
    "에너지 사용량",
    "에너지 발전량",
    "온실가스 배출량",
    "온실가스 감축량",
  ]

  return (
    <Wrapper>
      {buttons.map((label) => (
        <Button
          key={label}
          selected={selectedButton === label}
          onClick={() => onButtonClick(label)}
        >
          {label}
        </Button>
      ))}
    </Wrapper>
  )
}

export default ButtonGroup
